module.exports = __webpack_public_path__ + "assets/img/title2-78703aeb.png";